var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraRotateSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 14,
    width: 14,
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#180058",
    d: "M202.7 160L213.1 128.8C219.6 109.2 237.9 96 258.6 96L381.4 96C402.1 96 420.4 109.2 426.9 128.8L437.3 160L512 160C547.3 160 576 188.7 576 224L576 480C576 515.3 547.3 544 512 544L128 544C92.7 544 64 515.3 64 480L64 224C64 188.7 92.7 160 128 160L202.7 160zM160 369.9C160 373.8 161.4 377.6 164 380.5L212 434.5C218.4 441.7 229.6 441.7 235.9 434.5L283.9 380.5C286.5 377.6 287.9 373.8 287.9 369.9L287.9 368C287.9 359.2 280.7 352 271.9 352L247.9 352C247.9 312.2 280.1 280 319.9 280C324.3 280 328.6 280.4 332.8 281.2L367.7 241.9C353.1 235.5 336.9 232 319.9 232C253.6 232 199.9 285.7 199.9 352L175.9 352C167.1 352 159.9 359.2 159.9 368L159.9 369.9zM356 323.4C353.4 326.3 352 330.1 352 334L352 335.9C352 344.7 359.2 351.9 368 351.9L392 351.9C392 391.7 359.8 423.9 320 423.9C315.6 423.9 311.3 423.5 307.1 422.7L272.2 462C286.9 468.4 303 471.9 320 471.9C386.3 471.9 440 418.2 440 351.9L464 351.9C472.8 351.9 480 344.7 480 335.9L480 334C480 330.1 478.6 326.3 476 323.4L428 269.4C421.6 262.2 410.4 262.2 404.1 269.4L356.1 323.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraRotateSolidFull);
export default __webpack_public_path__ + "static/media/camera-rotate-solid-full.0db547462e723c9640d6fba43a2a1a5c.svg";
export { ForwardRef as ReactComponent };